import React from 'react';
import {
  Box,
  Container,
  Grid,
  Paper,
  Typography,
  LinearProgress,
  Chip,
  Divider,
} from '@mui/material';
import {
  TrendingUp,
  CheckCircle,
  Cancel,
  Sync as SyncIcon,
  FiberNew as NewIcon,
} from '@mui/icons-material';

export const Dashboard = () => {
  // Sample data - replace with actual API data
  const pipelineData = {
    new: { count: 45, percentage: 30 },
    qualified: { count: 38, percentage: 25 },
    disqualified: { count: 20, percentage: 15 },
    closedWon: { count: 25, percentage: 20 },
    closedLoss: { count: 12, percentage: 10 },
  };

  const todayLeads = 12;

  const syncStatus = {
    lastSync: '2025-08-21 10:30 AM',
    status: 'Synced',
    pendingTasks: 3,
  };

  return (
    <Box sx={{ py: 4, bgcolor: '#f8fafc', minHeight: '100vh' }}>
      <Container maxWidth="xl">
        {/* Header */}
        <Typography variant="h4" sx={{ mb: 4, fontWeight: 700, color: '#1e293b' }}>
          Lead Pipeline Dashboard
        </Typography>

        {/* Pipeline Overview */}
        <Grid container spacing={3}>
          {/* Pipeline Stats */}
          <Grid item xs={12} md={8}>
            <Paper sx={{ p: 3, borderRadius: 2 }}>
              <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
                Pipeline Overview
              </Typography>
              
              {/* Pipeline Stages */}
              <Box sx={{ mb: 4 }}>
                {[
                  { label: 'New', value: pipelineData.new, color: '#3b82f6' },
                  { label: 'Qualified', value: pipelineData.qualified, color: '#10b981' },
                  { label: 'Disqualified', value: pipelineData.disqualified, color: '#f59e0b' },
                  { label: 'Closed - Won', value: pipelineData.closedWon, color: '#059669' },
                  { label: 'Closed - Loss', value: pipelineData.closedLoss, color: '#dc2626' },
                ].map((stage) => (
                  <Box key={stage.label} sx={{ mb: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                      <Typography variant="body2" sx={{ color: '#475569' }}>
                        {stage.label}
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        {stage.value.count} ({stage.value.percentage}%)
                      </Typography>
                    </Box>
                    <LinearProgress
                      variant="determinate"
                      value={stage.value.percentage}
                      sx={{
                        height: 8,
                        borderRadius: 1,
                        bgcolor: '#f1f5f9',
                        '& .MuiLinearProgress-bar': {
                          bgcolor: stage.color,
                        },
                      }}
                    />
                  </Box>
                ))}
              </Box>
            </Paper>
          </Grid>

          {/* Today's Stats */}
          <Grid item xs={12} md={4}>
            <Grid container spacing={3}>
              {/* Today's New Leads */}
              <Grid item xs={12}>
                <Paper sx={{ p: 3, borderRadius: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                    <Box
                      sx={{
                        bgcolor: '#eef2ff',
                        borderRadius: 2,
                        p: 1,
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <NewIcon sx={{ color: '#4f46e5' }} />
                    </Box>
                    <Typography variant="h6">Today's New Leads</Typography>
                  </Box>
                  <Typography variant="h3" sx={{ fontWeight: 700, color: '#4f46e5' }}>
                    {todayLeads}
                  </Typography>
                </Paper>
              </Grid>

              {/* Sync Status */}
              <Grid item xs={12}>
                <Paper sx={{ p: 3, borderRadius: 2 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
                    <Typography variant="h6">Task Sync Status</Typography>
                    <Chip
                      icon={<SyncIcon />}
                      label={syncStatus.status}
                      color="success"
                      size="small"
                    />
                  </Box>
                  <Divider sx={{ my: 2 }} />
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="body2" color="text.secondary">
                      Last Synced
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {syncStatus.lastSync}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="body2" color="text.secondary">
                      Pending Tasks
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, color: '#dc2626' }}
                    >
                      {syncStatus.pendingTasks}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Dashboard;